// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_upload-module__container--28rW-{padding-top:56px;max-width:600px;margin:auto;padding-bottom:40px}@media screen and (max-width: 62.5625em){.decision_upload-module__container--28rW-{padding-top:8px}}\n", ""]);
// Exports
exports.locals = {
	"container": "decision_upload-module__container--28rW-"
};
module.exports = exports;
